module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.provider) ? _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('el-button', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "transition": "all 1s",
      "margin-right": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  }), _vm._v("\n          Volver\n        ")])], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-row', {
    staticStyle: {
      "height": "90px",
      "padding-top": "20px",
      "text-align": "right"
    }
  }, [_c('el-tag', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "effect": "dark",
      "type": _vm.statusType
    }
  }, [_vm._v("\n              " + _vm._s(_vm.getStatusNameOfTab()) + "\n            ")])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Datos generales",
      "name": "generalData"
    }
  }, [_c('el-row', {
    staticStyle: {
      "height": "70px",
      "text-align": "justify"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Cuit: " + _vm._s(_vm.provider.cuit) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Razón Social: " + _vm._s(_vm.provider.company) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Nombre de Fantasía: " + _vm._s(_vm.provider.companyName ? _vm.provider.companyName : '-') + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Servicios: \n                "), _vm._l((_vm.provider.rubros), function(rubro, index) {
    return _c('span', {
      key: rubro.idRubro
    }, [_vm._v("\n                " + _vm._s(rubro.nombre) + "\n                "), ((index + 1) < _vm.provider.rubros.length) ? _c('span', [_vm._v("\n                  /\n                ")]) : _vm._e()])
  })], 2)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              País: " + _vm._s(_vm.countryName(_vm.provider.generalData.idCountry)) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Provincia: " + _vm._s(_vm.provinceName(_vm.provider.generalData.idProvince)) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Ciudad: " + _vm._s(_vm.provider.generalData.city) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Dirección: " + _vm._s(_vm.provider.generalData.address + ' ' + _vm.provider.generalData.addressNumber) + "\n            ")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Teléfono: " + _vm._s(_vm.provider.generalData.phone) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              E-mail pago: " + _vm._s(_vm.provider.generalData.paymentEmail) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              E-mail recepción: " + _vm._s(_vm.provider.generalData.receiptEmail) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Código postal: " + _vm._s(_vm.provider.generalData.zipCode) + "\n            ")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Sujeto IVA: " + _vm._s(_vm.provider.generalData.typeIVA) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Persona: " + _vm._s(_vm.provider.generalData.personType) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Subtipo persona: " + _vm._s(_vm.provider.generalData.personSubType === 'Otro' ? _vm.provider.generalData.personSubTypeOther : (_vm.provider.generalData.personSubType ? _vm.provider.generalData.personSubType : '-')) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Alta de AFIP: \n              "), (_vm.provider.generalData.pdfAfip !== '0') ? _c('a', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "href": _vm.provider.generalData.pdfAfip,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n              ")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Datos de pago",
      "name": "paymentData"
    }
  }, [_c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Sucursal ICBC: " + _vm._s(_vm.bankBranchName(_vm.provider.paymentData.idBankBranch) ? _vm.bankBranchName(_vm.provider.paymentData.idBankBranch) : '-') + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Banco: " + _vm._s(_vm.bankName(_vm.provider.paymentData.idBank)) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Número de cta: " + _vm._s(_vm.provider.paymentData.accountNumber) + "\n            ")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Tipo de cta: " + _vm._s(_vm.bankAccountName(_vm.provider.paymentData.idBankAccountType)) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              CBU: " + _vm._s(_vm.provider.paymentData.cbu) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Constancia: \n              "), (_vm.provider.paymentData.pdfBank !== '0') ? _c('a', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "href": _vm.provider.paymentData.pdfBank,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n              ")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Datos impositivos",
      "name": "taxData"
    }
  }, [_c('el-divider', [_vm._v(" Ingresos Brutos ")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Constancia: \n              "), _c('a', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "href": _vm.provider.taxData.pdfIb,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n              ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Tipo: " + _vm._s(_vm.provider.taxData.ibType) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v(" "), _c('el-dropdown', {
    on: {
      "command": _vm.handlePdfsExempt
    }
  }, [_c('span', {
    class: _vm.provider.taxData.pdfsExempt.length > 0 ? 'el-dropdown-link' : ''
  }, [_vm._v("\n                  Constancia de exento"), (_vm.provider.taxData.pdfsExempt.length > 0) ? _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  }) : _vm._e()]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.provider.taxData.pdfsExempt), function(pdf, index) {
    return _c('el-dropdown-item', {
      key: pdf.idPdfExemption,
      attrs: {
        "command": pdf.pdfExempt
      }
    }, [_vm._v("PDF " + _vm._s(index))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Regimen de convenio: " + _vm._s(_vm.agreementRegimeTypeName(_vm.provider.taxData.idAgreementRegimeType)) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              CM05:\n              "), (_vm.provider.taxData.pdfCM05) ? _c('a', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "href": _vm.provider.taxData.pdfCM05,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n              ")]) : _c('span', [_vm._v(" - ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Jurisdicción sede: " + _vm._s(_vm.jurisdictionName(_vm.provider.taxData.jurisdictionHeadquarters)) + "\n            ")])], 1), _vm._v(" "), _c('el-row', [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n            Jurisdicciones:\n            "), (false) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.provider.taxData.jurisdictions,
      "height": "250",
      "disabled": true
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.provider[_vm.activeTab].idCompanyDataStatus === '1') ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-divider', [_vm._v(" Aceptar datos ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.rejectCompanyDataVisible = true
      }
    }
  }, [_vm._v(" Rechazar "), _c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.acceptCompanyData()
      }
    }
  }, [_vm._v(" Aceptar "), _c('i', {
    staticClass: "el-icon-check"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rechazar datos",
      "visible": _vm.rejectCompanyDataVisible,
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectCompanyDataVisible = $event
      }
    }
  }, [_vm._v("\n    Escriba el motivo por el cual rechaza los datos:\n    "), _c('el-input', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": "400",
      "placeholder": "Ingrese el motivo",
      "show-word-limit": true
    },
    model: {
      value: (_vm.newObservation),
      callback: function($$v) {
        _vm.newObservation = $$v
      },
      expression: "newObservation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rejectCompanyData()
      }
    }
  }, [_vm._v("\n        Aceptar\n      ")])], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e9803c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ProviderDetail.vue
// module id = 640
// module chunks = 1